exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-compatible div {\n  padding: 7px !important;\n}", ""]);

// exports
